import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_alert = _resolveComponent("md-alert")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "FAQ-Paar hinzufügen",
    icon: "question_answer"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Füge ein neues FAQ-Paar hinzu und stelle so weitere Informationen für deine Nutzer bereit. Ein FAQ-Paar enthält immer Beispieläußerungen und die dazu gehörigen Antworten. ")
    ]),
    body: _withCtx(() => [
      _createVNode(_component_md_input_field, {
        variant: "outlined",
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
        label: "Name",
        ref: "nameInput",
        "input-validator": _ctx.nameValidator
      }, null, 8, ["modelValue", "input-validator"]),
      _createVNode(_component_md_alert, {
        class: "alert",
        icon: "warning",
        variant: "info"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Du musst nach dem dieses FAQ-Paar erstellt hast, diesem in allen Sprachen mindestens eine Beispieläußerung hinzufügen. Andernfalls kann dein Chatbot nicht trainiert werden. ")
        ]),
        _: 1
      })
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Abbrechen")
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        onClick: _ctx.createFaqPair
      }, {
        default: _withCtx(() => [
          _createTextVNode("FAQ-Paaar hinzufügen")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}